<template>
  <div class="footer-logo-container" :class="{ collapse: collapse }">
    <transition name="footerLogoFade">
      <div class="collapse" v-if="collapse">
        <h1 class="footer-title">{{ title }}</h1>
        <div class="img">
          <img src="./longmeng.png" class="footer-logo" />
        </div>
      </div>
      <div class="expand" v-else>
        <div class="img">
          <img src="./longmeng.png" class="footer-logo" />
        </div>
        <h1 class="footer-title">{{ title }}</h1>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: "龙盟科技提供技术支持",
      logo: "./longmeng.png"
    };
  }
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.footer-logo-container {
  position: relative;
  width: 100%;
  height: 100px;
  // line-height: 50px;
  background: #2b2f3a00;
  text-align: center;
  overflow: hidden;
  // 确保logo在菜单栏下面
  z-index: -1;

  & .expand {
    height: 100%;
    width: 100%;

    & .collapse {
      width: 45px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .footer-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 500;
      line-height: 50px;
      font-size: 13px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
    .img {
      img {
        width: 66%;
      }
    }
  }

  &.collapse {
    .footer-logo {
      margin-right: 0px;
      margin-bottom: 2vh;
      width: 80%;
    }
  }
}
</style>
